var map = {
	"./amex.png": 1869,
	"./aura.png": 3562,
	"./chip.png": 3136,
	"./dankort.png": 9898,
	"./dinersclub.png": 1265,
	"./discover.png": 9252,
	"./elo.png": 4703,
	"./hipercard.png": 6112,
	"./jcb.png": 5323,
	"./laser.png": 819,
	"./maestro.png": 3719,
	"./mastercard.png": 3363,
	"./mir.png": 5137,
	"./troy.png": 4738,
	"./uatp.png": 9993,
	"./unionpay.png": 5489,
	"./visa.png": 9270,
	"./visaelectron.png": 1332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2605;